(function(){
    class ShowReel{
        constructor(){
            this._gamesToPlay = [];
        }

        initialise(json){
            let engine = gdk.getEngineSupplier();
            if (json[engine]){
                this._gamesToPlay = json[engine].gamesToPlay;            
                messageBus.subscribe("common:ReadyToStart", this.forceNexGame.bind(this));
            }           
        }

        forceNexGame(){
            if (this._gamesToPlay.length > 0){                
                let nextGame = this._gamesToPlay[0];
                gdk.gameForces(JSON.parse(JSON.stringify(nextGame)));
                this._gamesToPlay.shift();
            }
        }
    }

    resourceManager.registerController("ShowReel", function() {
        return new ShowReel();
    });
}());